// Hall-entrance check-in — server-backed so the count is shared across devices/
// doors and survives a refresh. A party may enter partially (e.g. 2 of 4 now,
// the rest on a later QR scan); `entered_count` on the reservation tracks how
// many are in, capped at seat_count.

import { useCallback, useEffect, useState } from 'react';
import { adminApi } from '../auth.ts';

export type CheckInResult = {
  enteredCount: number;
  seatCount: number;
  enteredAt: string | null;
};

/** Admit `delta` guests of a party into the hall (negative = undo). */
export function admitGuests(reservationId: string, delta: number): Promise<CheckInResult> {
  return adminApi<CheckInResult>(`/admin/reservations/${reservationId}/checkin`, {
    method: 'POST',
    body: { delta },
  });
}

export type CheckInStats = { parties: number; seats: number };

/** Live "salona giren" totals, with a manual refresh after each admit. */
export function useCheckInSummary(): CheckInStats & { refresh: () => void } {
  const [stats, setStats] = useState<CheckInStats>({ parties: 0, seats: 0 });

  const refresh = useCallback(() => {
    adminApi<CheckInStats>('/admin/checkin-summary')
      .then(setStats)
      .catch(() => {
        /* keep last good value */
      });
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...stats, refresh };
}
